import { useState } from "react";
import { motion } from "framer-motion";

import BannerSlideshow from "../components/Home/BannerSlideShow";
import OffersTicker from "../components/Offers/OffersTicker";
import Brands from "../components/Products/Brands";
import BrandPreview from "../components/Products/BrandPreview";
import Footer from "../components/Home/Footer";
import { useBrandContext, Brand } from "../context/BrandContext";

const Home = () => {
  const { brands } = useBrandContext();
  const [selectedBrand, setSelectedBrand] = useState<Brand | null>(null);

  return (
    <motion.main
      className="w-full overflow-x-hidden bg-[#fbe7e7]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* HERO */}
      <BannerSlideshow />

      {/* OFFERS */}
      <OffersTicker />

      {/* BRANDS */}
      <section className="max-w-7xl mx-auto px-4">
        <Brands brands={brands} onBrandClick={setSelectedBrand} />
      </section>

      {/* BRAND PREVIEW */}
      <section className="max-w-7xl mx-auto px-4">
        <BrandPreview brand={selectedBrand} />
      </section>

      <Footer />
    </motion.main>
  );
};

export default Home;
